// 将登录时获取的token值存储到本地浏览器中
export const setItem = (name, data) => {
  window.sessionStorage.setItem(name, JSON.stringify(data))
}
// 将登录时存储的token值从本地浏览器中拿出来
export const getItem = name => {
  return JSON.parse(window.sessionStorage.getItem(name))
}
// 将本地存储的token值给删除
export const removeItem = name => {
  window.sessionStorage.removeItem(name)
}



// WEBPACK FOOTER //
// ./src/untils/storage.js